var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"acount-info-main-div"},[(_vm.loginUser.account)?_c('div',[_c('account-info-sub')],1):_vm._e(),_c('div',{staticClass:"trading-record-div"},[_c('trading-record-sub')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }